import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'columns'})
export class ColumnsPipe implements PipeTransform {
  transform(value: any) {
    return Object.keys(value).map((key) => {
      if ((value[key] !== null) && (value[key].constructor === Object)) {
        return {
        key: key,
        value: this.getUserName(value[key]),
        columnName: this.getColumnName(key)
      };
      }
      return {
        key: key,
        value: this.getValue(value[key]),
        columnName: this.getColumnName(key)
      };
    });
  }

  getColumnName(key) {
    const customName = key.replace(/([A-Z])/g, ' $1').trim();
    return customName;
  }

  getUserName(item) {
    return `${item.firstName} ${item.lastName}`;
  }

  getValue(item) {
    return (item === null) ? 'N/A' : item;
  }
}
